import { useState } from 'react';
import { fetchApiData } from '../../Utils/ApiCalls';
import useFormStatus from '../../Hooks/useFormStatus';
import { INCREASE_FREE_TRIAL_ENDPOINT } from '../../urls';
import IncreaseFreeTrial from './IncreaseFreeTrial';
import { Button, Input } from '@attentive-platform/stem-ui';

export const IncreaseFreeTrialForm = () => {
  const { successMessage, errorMessage, handleApiResult } = useFormStatus();

  const [email, setEmail] = useState('');
  const [numberOfDays, setNumberOfDays] = useState('1');

  const handleSubmit = async e => {
    e.preventDefault();

    const result = await fetchApiData({
      endpoint: INCREASE_FREE_TRIAL_ENDPOINT,
      data: {
        email: email.toLowerCase(),
        free_trial_days: numberOfDays.replace(/^0+/, '')
      }
    });

    handleApiResult(result);
    setEmail('');
    setNumberOfDays(0);
  };
  return (
    <form onSubmit={handleSubmit}>
      {(errorMessage || successMessage) && (
        <div className={`alert ${errorMessage ? 'alert-danger' : 'alert-success'}`} role='alert'>
          {errorMessage || successMessage}
        </div>
      )}
      <div className='mb-3'>
        <Input
          label='Admin Email'
          type='email'
          value={email}
          onChange={e => setEmail(e.target.value)}
          placeholder='Admin Email'
          required
          fullWidth
        />
      </div>
      <IncreaseFreeTrial numberOfDays={numberOfDays} setNumberOfDays={setNumberOfDays} />
      <div className='flex justify-end'>
        <Button color='primary' size='medium' variant='contained' type='submit' className='text-base'>
          Submit
        </Button>
      </div>
    </form>
  );
};
